import "react-app-polyfill/ie11";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
//import * as serviceWorker from './serviceWorker';
import { HashRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import store from "./store/store";
import { Provider } from "react-redux";

ReactDOM.render(
    <React.StrictMode>
        <Suspense fallback="loading">
            <Provider store={store}>
                <HashRouter>
                    <ScrollToTop>
                        <App />
                    </ScrollToTop>
                </HashRouter>
            </Provider>
        </Suspense>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
